var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Image } from "..";
import { observable, computed } from "mobx";
export class JackpotWinningAnimation {
    constructor(cms) {
        this.jackpotId = cms.JackpotID;
        this.backgroundImage = new Image(cms.BackgroundImage);
        this.jackpotWinsData = [];
    }
    setWinning(jackpotData) {
        this.jackpotWinsData.push({ jackpotWinData: jackpotData, isWon: false });
    }
    hasId(jackpotId) {
        let split = this.jackpotId.split(" ");
        return !!split.find(x => x.toUpperCase() === jackpotId.toUpperCase());
    }
    get WonJackpot() {
        return this.jackpotWinsData.find(x => x.isWon === false);
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], JackpotWinningAnimation.prototype, "jackpotWinsData", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], JackpotWinningAnimation.prototype, "WonJackpot", null);
//# sourceMappingURL=JackpotWinningAnimation.js.map